import * as React from 'react';
import { useGroundingMenu_unstable } from './useGroundingMenu';
import { renderGroundingMenu_unstable } from './renderGroundingMenu';
import { useGroundingMenuStyles_unstable } from './useGroundingMenuStyles.styles';
import type { GroundingMenuProps } from './GroundingMenu.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingMenu component - TODO: add more docs
export const GroundingMenu: ForwardRefComponent<GroundingMenuProps> = React.forwardRef((props, ref) => {
  const state = useGroundingMenu_unstable(props, ref);

  useGroundingMenuStyles_unstable(state);
  return renderGroundingMenu_unstable(state);
});

GroundingMenu.displayName = 'GroundingMenu';
